// extracted by mini-css-extract-plugin
export default {"myAccount":"myAccount_myAccount__l4eBd","myAccount__tabs":"myAccount_myAccount__tabs__Uz2zb"};